import { useTranslation } from 'react-i18next'
import parseISO from 'date-fns/parseISO'
import { DateUtils } from '@ocean/utils'
import { namespace } from 'modules/Notifications/localization'
import { EventNotificationItem } from 'modules/Notifications/types'
import { NotificationType } from 'modules/Notifications/types'
import { EventWrapper, Info, Text } from './Event.styled'

const I18_PATH = `${namespace}:notifications.eventNotification`

type EventProps = {
  event: EventNotificationItem
}

const Event: React.FC<EventProps> = ({ event }) => {
  const { t } = useTranslation()
  const { name, deadline, type } = event || {}
  const deadlineDate = deadline ? parseISO(deadline) : new Date(0)
  const { years, months, days, hours, minutes } = DateUtils.getIntervalFromNowGMT(deadlineDate)

  function localizeCountdownItem(localizationKey: string, value?: number) {
    return value ? `${t(`${I18_PATH}.countDown.${localizationKey}`, { count: value })} ` : ''
  }

  const localizedYears = localizeCountdownItem('year', years)
  const localizedMonths = localizeCountdownItem('month', months)
  const localizedDays = localizeCountdownItem('day', days)
  const localizedHours = localizeCountdownItem('hour', hours)
  const localizedMinutes = localizeCountdownItem('minute', minutes)
  const countdown = `${localizedYears}${localizedMonths}${localizedDays}${localizedHours}${localizedMinutes}`
  const localDeadlineDate = deadline && DateUtils.convertUTCDateToLocalDate(deadline)
  const shouldShowCountdown = !!countdown && !(years || months || days)

  function getEventNameLabel() {
    switch (true) {
      case type === NotificationType.VirtualClassroom:
        return t(`${I18_PATH}.virtualClassroomNextEvent`)
      case type === NotificationType.SimulatorTraining:
        return t(`${I18_PATH}.simulatorTraining`)
      default:
        return ''
    }
  }

  return (
    <EventWrapper key='name'>
      <Info title={name} cut data-test='EventNotificationsName'>
        {`${getEventNameLabel()}: `}
        <Text>{name}</Text>
      </Info>
      {localDeadlineDate && (
        <Info data-test='EventNotificationsDeadline'>
          {`${t(`${I18_PATH}.date`)}: `}
          <Text>{DateUtils.formatShortDate(localDeadlineDate)}</Text>
          {` ${t(`${I18_PATH}.at`)} `}
          <Text>{DateUtils.formatShortTime(localDeadlineDate)}</Text>
        </Info>
      )}
      {shouldShowCountdown && (
        <Info data-test='EventNotificationsStartsIn'>
          {`${t(`${I18_PATH}.startsIn`)}: `}
          <Text>{countdown}</Text>
        </Info>
      )}
    </EventWrapper>
  )
}

export default Event
